import {
	CLEAR_ELECTRONIC_RECEIPTS_HEADER_FILTERS,
	CONFIRM_ELECTRONIC_RECEIPTS_HEADERS_ERROR,
	CONFIRM_ELECTRONIC_RECEIPTS_HEADERS_SUCCESS,
	SET_ELECTRONIC_RECEIPTS_HEADER_FILTERS
} from 'constants/ActionsTypes'
import { ElectronicReceiptsActions } from 'constants/ActionsTypesTs'
import {
	ICancelElectronicReceiptsAction,
	ICancelElectronicReceiptsActionSuccess,
	ICancelElectronicReceiptsParams,
	ICancelElectronicReceiptsResponse,
	IConfirmElectronicReceiptsHeadersAction,
	IConfirmElectronicReceiptsHeadersParams,
	IConsultElectronicReceiptsAction,
	IConsultElectronicReceiptsActionSuccess,
	IConsultElectronicReceiptsParams,
	IConsultElectronicReceiptsResponse,
	IGetElectronicReceiptsHeadersAction,
	IGetElectronicReceiptsHeadersParams,
	IGetElectronicReceiptsHeadersResponse,
	IGetElectronicReceiptsHeadersSuccessAction,
	IValidateElectronicReceiptAction,
	IValidateElectronicReceiptActionSuccess,
	IValidateElectronicReceiptParams,
	IValidateElectronicReceiptResponse
} from 'models/ElectronicReceipts'

export const getElectronicReceiptsHeaders = (
	payload: IGetElectronicReceiptsHeadersParams
): IGetElectronicReceiptsHeadersAction => ({
	type: ElectronicReceiptsActions.GET_ELECTRONIC_RECEIPTS_HEADERS,
	payload
})

export const getElectronicReceiptsHeadersSuccess = (
	payload: IGetElectronicReceiptsHeadersResponse
): IGetElectronicReceiptsHeadersSuccessAction => ({
	type: ElectronicReceiptsActions.GET_ELECTRONIC_RECEIPTS_HEADERS_SUCCESS,
	payload
})

export const confirmElectronicReceiptsHeaders = (
	payload: IConfirmElectronicReceiptsHeadersParams
): IConfirmElectronicReceiptsHeadersAction => ({
	type: ElectronicReceiptsActions.CONFIRM_ELECTRONIC_RECEIPTS_HEADERS,
	payload
})

export const confirmElectronicReceiptsHeadersSuccess = (payload: any) => ({
	type: CONFIRM_ELECTRONIC_RECEIPTS_HEADERS_SUCCESS,
	payload
})

export const confirmElectronicReceiptsHeadersError = (payload: any) => ({
	type: CONFIRM_ELECTRONIC_RECEIPTS_HEADERS_ERROR,
	payload
})

export const clearElectronicReceiptsHeaderFilters = (payload: any) => ({
	type: CLEAR_ELECTRONIC_RECEIPTS_HEADER_FILTERS,
	payload
})

export const setElectronicReceiptsHeaderFilters = (payload: any) => ({
	type: SET_ELECTRONIC_RECEIPTS_HEADER_FILTERS,
	payload
})

export const validateElectronicReceipts = (
	payload: IValidateElectronicReceiptParams
): IValidateElectronicReceiptAction => ({
	payload,
	type: ElectronicReceiptsActions.VALIDATE_ELECTRONIC_RECEIPTS
})

export const validateElectronicReceiptsSuccess = (
	payload: IValidateElectronicReceiptResponse
): IValidateElectronicReceiptActionSuccess => ({
	payload,
	type: ElectronicReceiptsActions.VALIDATE_ELECTRONIC_RECEIPTS_SUCCESS
})

export const consultElectronicReceipts = (
	payload: IConsultElectronicReceiptsParams
): IConsultElectronicReceiptsAction => ({
	payload,
	type: ElectronicReceiptsActions.CONSULT_ELECTRONIC_RECEIPTS
})

export const consultElectronicReceiptsSuccess = (
	payload: IConsultElectronicReceiptsResponse
): IConsultElectronicReceiptsActionSuccess => ({
	payload,
	type: ElectronicReceiptsActions.CONSULT_ELECTRONIC_RECEIPTS_SUCCESS
})

export const cancelElectronicReceipts = (
	payload: ICancelElectronicReceiptsParams
): ICancelElectronicReceiptsAction => ({
	payload,
	type: ElectronicReceiptsActions.CANCEL_ELECTRONIC_RECEIPTS
})

export const cancelElectronicReceiptsSuccess = (
	payload: ICancelElectronicReceiptsResponse
): ICancelElectronicReceiptsActionSuccess => ({
	payload,
	type: ElectronicReceiptsActions.CANCEL_ELECTRONIC_RECEIPTS_SUCCESS
})
